import React, { useState, useContext } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { useCookies } from "react-cookie";
import flattenDeep from "lodash/flattenDeep";
import Proptypes from "prop-types";

import useGet from "../../hooks/useGet";
import Loading from "../Loading";

const apiUrl = "/wp-json/pan/v1/faqs";

const FeatureGrid = props => {
  const [query, setQuery] = useState("");
  const [cookies, setCookie] = useCookies([props.cookieName]);
  const [tabsData, setTabsData] = useState(props.tabsData);

  /**
   * Render Data Tabs
   * Loop over the props data to render the Tab titles
   *
   */
  function renderDataTabs(data) {
    return data.map(tab => {
      return (
        <Tab key={tab.index}>
          <h2>{tab.title}</h2>
        </Tab>
      );
    });
  }

  return (
    <Tabs className="ReactTabs">
      <TabList>{renderDataTabs(props.tabsData)}</TabList>
      {props.children}
    </Tabs>
  );
};

FeatureGrid.propTypes = {
  children: Proptypes.node
};

export default FeatureGrid;
